import React from 'react';

// Компонент иконки корзины
const CartIcon = ({ size = 'medium', className = '' }) => {
  const sizeClasses = {
    small: 'w-6 h-6',
    medium: 'w-8 h-8',
    large: 'w-10 h-10',
    xlarge: 'w-12 h-12'
  };

  return (
    <img 
      src={new URL('./images/icons/cart.png', import.meta.url).href}
      alt="Корзина"
      className={`${sizeClasses[size]} ${className}`}
    />
  );
};

// Компонент иконки "Купить сейчас"
export const BuyNowIcon = ({ size = 'medium', className = '' }) => {
  const sizeClasses = {
    small: 'w-6 h-6',
    medium: 'w-8 h-8',
    large: 'w-10 h-10',
    xlarge: 'w-12 h-12'
  };

  return (
    <img 
      src={new URL('./images/icons/buy-now.png', import.meta.url).href}
      alt="Купить"
      className={`${sizeClasses[size]} ${className}`}
    />
  );
};

export default CartIcon;